module.exports = __webpack_public_path__ + "img/heart.3123a3c9.svg";